import React from "react";

const TextArea = (props: any) => {
  return (
    <>
      <label htmlFor={props.name} className="form-label form__label">
        MAX. 500 CHARACTERS
      </label>
      <textarea
        className="form-input form__input form__input--textarea"
        id={props.id || props.name}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        placeholder={props.placehold}
        readOnly={props.readOnly}
        disabled={props.disabled}
      />
    </>
  );
};

export default TextArea;
